export default __webpack_public_path__ + "static/media/dash-ui.ebe1db38.png";